import { ITemplateStylingSettings } from '@/components/settings-page/platformSettings/templatesSettings/types';
import * as docx from 'docx';
import { DefaultTheme } from 'styled-components/dist/types';
import { getDocxImage, transparentDocxTableBorders } from '../utils';

const createHeaderImage = async (logoUrl: string) => {
  if (!logoUrl) {
    return new docx.Paragraph({});
  }

  const imageData = (await getDocxImage(logoUrl)) ?? '';

  if (!imageData) return new docx.Paragraph({});

  const img = new Image();
  img.src = URL.createObjectURL(new Blob([imageData as BlobPart]));
  await new Promise((resolve) => (img.onload = resolve));

  let newWidth = img.naturalWidth;
  let newHeight = img.naturalHeight;

  const maxWidth = 300;
  const maxHeight = 32;

  if (newWidth > maxWidth || newHeight > maxHeight) {
    const widthRatio = maxWidth / newWidth;
    const heightRatio = maxHeight / newHeight;
    const ratio = Math.min(widthRatio, heightRatio);

    newWidth = newWidth * ratio;
    newHeight = newHeight * ratio;
  }

  return new docx.Paragraph({
    children: [
      new docx.ImageRun({
        type: 'png',
        data: imageData,
        transformation: {
          width: newWidth,
          height: newHeight
        }
      })
    ]
  });
};

export const getDocxHeader = async (templateStylingData: ITemplateStylingSettings, theme: DefaultTheme) => {
  const header = new docx.Header({
    children: [
      new docx.Table({
        width: {
          size: 12000,
          type: docx.WidthType.DXA
        },
        indent: {
          size: -800,
          type: docx.WidthType.DXA
        },
        rows: [
          new docx.TableRow({
            children: [
              new docx.TableCell({
                children: [],
                borders: transparentDocxTableBorders,
                shading: {
                  fill: templateStylingData?.accentColor || '#5A6771'
                },
                verticalAlign: docx.VerticalAlign.CENTER,
                margins: {
                  top: 0,
                  bottom: 0,
                  left: 800,
                  right: 0
                }
              })
            ],
            height: {
              value: 75,
              rule: docx.HeightRule.EXACT
            }
          }),
          new docx.TableRow({
            children: [
              new docx.TableCell({
                children: [await createHeaderImage(templateStylingData?.logo ?? '')],
                borders: transparentDocxTableBorders,
                shading: {
                  fill: theme.layer[12]
                },
                verticalAlign: docx.VerticalAlign.CENTER,
                margins: {
                  top: 0,
                  bottom: 0,
                  left: 800,
                  right: 0
                }
              })
            ],
            height: {
              value: 1100,
              rule: docx.HeightRule.EXACT
            }
          })
        ]
      })
    ]
  });

  return header;
};
